import { combineReducers } from "redux";
import currentUserReducer from "./actions-reducers/user";
import languageReducer from "./actions-reducers/language";
import stagesReducer from "./actions-reducers/stages";

const rootReducer = combineReducers({ currentUser: currentUserReducer, language: languageReducer, stages: stagesReducer });

export default rootReducer;
